export default "__VITE_ASSET__d612f175__"